import { Inject, Injectable } from '@angular/core';
import { CONFIGS_OPTIONS_SYSTEM_CONFIGS } from '../token/confings.token';
import { IConfigsRepository } from '../../domain-layer/repository/configs.respository';
import { map } from 'rxjs';
import { configsFull } from '../../domain-layer/entity/configs-options.entity';

@Injectable()
export class ConfigsApplication {
  constructor(
    @Inject(CONFIGS_OPTIONS_SYSTEM_CONFIGS) private repo: IConfigsRepository,
  ) {}
  updateConfigs(configs: configsFull) {
    return this.repo.updateConfigs(configs).pipe(map((res) => res));
  }
  getConfigsValue() {
    return this.repo.getConfigsValue();
  }
}
